export default __webpack_public_path__ + "assets/images/76147b3960663a97bb7a87e33e77f168.png";